import React from 'react';
import { Select as RxSelect } from '@wearejh/rx-form';
import { RxValidateFn } from '@wearejh/rx-form/lib/types';
import { useFieldError } from '@wearejh/rx-form/lib/hooks/useFieldError';

import { ErrorFor } from './ErrorFor';

type SelectProps = {
    field: string;
    id?: string;
    initialValue?: string;
    label?: string;
    onChange?: (e: any) => void;
    options: { label: string; value: string; disabled?: boolean; selected?: boolean }[];
    required?: boolean;
    validate?: RxValidateFn;
    disabled?: boolean;
};

export function Select(props: SelectProps) {
    const { label, id, field, validate, options, required } = props;
    const error = useFieldError(props.field);

    const hasError = !!error;

    return (
        <>
            <label htmlFor={id || field}>
                {label}
                {required && ' *'}
            </label>
            <RxSelect
                data-error={hasError}
                field={field}
                id={id || field}
                validate={validate}
                options={options}
                onChange={props.onChange}
                initialValue={props.initialValue}
                disabled={props.disabled}
            />
            <ErrorFor field={field} />
        </>
    );
}

Select.defaultProps = {
    required: false,
};
